$( document ).ready(function() {
    resizeProjectSlides();
    $( window ).resize(function() {
        resizeProjectSlides();
    });
});

function resizeProjectSlides() {
    if ($(window).width() > 768) {
        $(".teaserhome").each(function () {
            $(this).find(".slide").each(function () {
                var imgHeight = $(this).find(".slide-image > img").height();
                var containerHeight = $(this).find(".slide-image").height() + 1;

                var newHeight = imgHeight - containerHeight;

                $(this).find(".slide-content-inner > .right").css("min-height", newHeight);

            })
        })
    }
}